// src/components/Breadcrumbs.js
import React from "react";
import bredcrumbs_icon from "../../assets/images/bredcrumbs_icon.svg";

const Breadcrumbs = ({ items }) => {
  return (
    <div className="common_bredcrunbs">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <ul className="bredcrumbs d-flex align-items-center">
              {items.map((item, index) => (
                <React.Fragment key={index}>
                  <li>
                    {item.active ? (
                      <span className="active">{item.label}</span>
                    ) : (
                      <a href={item.link || "#"}>{item.label}</a>
                    )}
                  </li>
                  
                  {index < items.length - 1 && (
                    <li>
                      <img src={bredcrumbs_icon} alt=">" />
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
